module.exports = __webpack_public_path__ + "img/addr.2e48417b.png";